import { Controller } from '@hotwired/stimulus';

export default class SchoolRegisterRenewalSelectionController extends Controller {
  static targets = [
    'row',
    'checkbox',
    'form'
  ];

  static values = {
    formUrl: String,
    studyingModelDefaultCourseIds: Array
  };

  toggleCheckbox() {
    this.formTarget.classList.add('opacity-50');

    const form = new FormData(this.formTarget);

    for (const checkbox of this.checkboxTargets) {
      checkbox.disabled = true;
    }

    for (const row of this.rowTargets) {
      row.classList.add('unhover');
    }

    const url = new URL(this.formUrlValue, location.origin);
    url.search = new URLSearchParams(form).toString();

    this.element.src = url.href;
    this.element.reload();
  }

  studyingModelCourseCheck() {
    for (const checkbox of this.checkboxTargets) {
      if (this.studyingModelDefaultCourseIdsValue.includes(parseInt(checkbox.value))) {
        checkbox.checked  = true;
        checkbox.disabled = false;
      } else {
        checkbox.checked = false;
      }
    }

    this.toggleCheckbox();
  }
}
